// One shared ticking `now` for the board's expiry countdowns. The footer's
// time-to-expiry tile is a pure function of (selected expiry - now); a minute-
// resolution countdown only needs a coarse tick, so ONE 30s interval drives
// every card rather than 8 separate timers. Cards call useNow() and derive
// their own countdown string from the returned Date via formatTimeToExpiry.
//
// The interval is cleaned up on unmount. Each consumer mounts its own hook
// instance (8 cards -> 8 intervals would defeat the purpose), so this is meant
// to be called ONCE high in the tree (the page) and the value threaded down --
// see market-probabilities/index.tsx, which passes `now` into each card. Kept here,
// not in the provider, so the 30s render-tick churn stays out of the pricing
// state.
import { useEffect, useState } from 'react';

const NOW_TICK_MS = 30000;

export function useNow(tickMs: number = NOW_TICK_MS): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const handle = setInterval(() => setNow(new Date()), tickMs);
    return () => clearInterval(handle);
  }, [tickMs]);
  return now;
}
